import { render, staticRenderFns } from "./NiceClassType.vue?vue&type=template&id=5c15a0a8&"
import script from "./NiceClassType.vue?vue&type=script&lang=js&"
export * from "./NiceClassType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports